import { render, staticRenderFns } from "./common-swiper-banner.vue?vue&type=template&id=23320b20&scoped=true"
import script from "./common-swiper-banner.vue?vue&type=script&lang=js"
export * from "./common-swiper-banner.vue?vue&type=script&lang=js"
import style0 from "./common-swiper-banner.vue?vue&type=style&index=0&id=23320b20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23320b20",
  null
  
)

export default component.exports